module.exports = __webpack_public_path__ + "img/sheets.beecdffa.png";